var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styles from "./ScoreColorFormatting.module.scss";
export var ScoreColorFormatting = function (_a) {
    var data = _a.data, getColor = _a.getColor, _b = _a.showPercent, showPercent = _b === void 0 ? false : _b;
    var color = getColor(data.score);
    return (_jsxs("div", __assign({ className: styles.scoreColorFormattingContainer, style: {
            color: color.text,
            backgroundColor: color.color,
            border: color.border ? "1px solid ".concat(color.border) : "none",
        } }, { children: [data.score, showPercent && "%"] })));
};
